var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "batch-setting" },
    [
      _c(
        "el-card",
        { staticClass: "config-card", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("i", { staticClass: "el-icon-setting" }),
              _vm._v(" "),
              _c("span", [_vm._v("选项配置")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "config-options" },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { label: "预定推送" },
                  model: {
                    value: _vm.configOptions.invoice,
                    callback: function ($$v) {
                      _vm.$set(_vm.configOptions, "invoice", $$v)
                    },
                    expression: "configOptions.invoice",
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-message" }),
                  _vm._v(" 预定推送\n        "),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  attrs: { label: "外卖与运费" },
                  model: {
                    value: _vm.configOptions.delivery,
                    callback: function ($$v) {
                      _vm.$set(_vm.configOptions, "delivery", $$v)
                    },
                    expression: "configOptions.delivery",
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-truck" }),
                  _vm._v(" 外卖与运费\n        "),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  attrs: { label: "开票配置" },
                  model: {
                    value: _vm.configOptions.openBill,
                    callback: function ($$v) {
                      _vm.$set(_vm.configOptions, "openBill", $$v)
                    },
                    expression: "configOptions.openBill",
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-document" }),
                  _vm._v(" 开票配置\n        "),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  attrs: { label: "营业设置" },
                  model: {
                    value: _vm.configOptions.business,
                    callback: function ($$v) {
                      _vm.$set(_vm.configOptions, "business", $$v)
                    },
                    expression: "configOptions.business",
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-time" }),
                  _vm._v(" 公告设置\n        "),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  attrs: { label: "营业时间配置" },
                  model: {
                    value: _vm.configOptions.businessTime,
                    callback: function ($$v) {
                      _vm.$set(_vm.configOptions, "businessTime", $$v)
                    },
                    expression: "configOptions.businessTime",
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-clock" }),
                  _vm._v(" 营业时间配置\n        "),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  attrs: { label: "点餐模式" },
                  model: {
                    value: _vm.configOptions.orderMode,
                    callback: function ($$v) {
                      _vm.$set(_vm.configOptions, "orderMode", $$v)
                    },
                    expression: "configOptions.orderMode",
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-food" }),
                  _vm._v(" 点餐模式\n        "),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  attrs: { label: "预订设置" },
                  model: {
                    value: _vm.configOptions.booking,
                    callback: function ($$v) {
                      _vm.$set(_vm.configOptions, "booking", $$v)
                    },
                    expression: "configOptions.booking",
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-date" }),
                  _vm._v(" 预订设置\n        "),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  attrs: { label: "繁忙时段" },
                  model: {
                    value: _vm.configOptions.busyTime,
                    callback: function ($$v) {
                      _vm.$set(_vm.configOptions, "busyTime", $$v)
                    },
                    expression: "configOptions.busyTime",
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-timer" }),
                  _vm._v(" 繁忙时段\n        "),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  attrs: { label: "福利社" },
                  model: {
                    value: _vm.configOptions.welfare,
                    callback: function ($$v) {
                      _vm.$set(_vm.configOptions, "welfare", $$v)
                    },
                    expression: "configOptions.welfare",
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-present" }),
                  _vm._v(" 福利社\n        "),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  attrs: { label: "预约时间段" },
                  model: {
                    value: _vm.configOptions.bookingTime,
                    callback: function ($$v) {
                      _vm.$set(_vm.configOptions, "bookingTime", $$v)
                    },
                    expression: "configOptions.bookingTime",
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-time" }),
                  _vm._v(" 预约时间段\n        "),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  attrs: { label: "二维码背景图" },
                  model: {
                    value: _vm.configOptions.qrBgImage,
                    callback: function ($$v) {
                      _vm.$set(_vm.configOptions, "qrBgImage", $$v)
                    },
                    expression: "configOptions.qrBgImage",
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-picture" }),
                  _vm._v(" 二维码背景图\n        "),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "setting-content" }, [
        _c(
          "div",
          { staticClass: "left-panel" },
          [
            _vm.configOptions.invoice
              ? _c(
                  "el-card",
                  { staticClass: "setting-card", attrs: { shadow: "hover" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card-header",
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("i", { staticClass: "el-icon-message" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("预定推送设置")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-content" }, [
                      _c("div", { staticClass: "push-setting" }, [
                        _c(
                          "div",
                          { staticClass: "push-item" },
                          [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("自提推送："),
                            ]),
                            _vm._v(" "),
                            _c("el-switch", {
                              model: {
                                value: _vm.pushSetting.selfPickup,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pushSetting, "selfPickup", $$v)
                                },
                                expression: "pushSetting.selfPickup",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "setting-text" },
                              [
                                _vm._v(
                                  "\n                  系统将在预定时间前\n                  "
                                ),
                                _c("el-input", {
                                  staticClass: "time-input",
                                  model: {
                                    value: _vm.pushSetting.selfPickupTime,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pushSetting,
                                        "selfPickupTime",
                                        $$v
                                      )
                                    },
                                    expression: "pushSetting.selfPickupTime",
                                  },
                                }),
                                _vm._v(
                                  "\n                  进行推送\n                "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "push-item" },
                          [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("外卖推送："),
                            ]),
                            _vm._v(" "),
                            _c("el-switch", {
                              model: {
                                value: _vm.pushSetting.delivery,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pushSetting, "delivery", $$v)
                                },
                                expression: "pushSetting.delivery",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "setting-text" },
                              [
                                _vm._v(
                                  "\n                  系统将在预定时间前\n                  "
                                ),
                                _c("el-input", {
                                  staticClass: "time-input",
                                  model: {
                                    value: _vm.pushSetting.deliveryTime,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pushSetting,
                                        "deliveryTime",
                                        $$v
                                      )
                                    },
                                    expression: "pushSetting.deliveryTime",
                                  },
                                }),
                                _vm._v(
                                  "\n                  进行推送\n                "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.configOptions.openBill
              ? _c(
                  "el-card",
                  { staticClass: "setting-card", attrs: { shadow: "hover" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card-header",
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("i", { staticClass: "el-icon-document" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("开票配置")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-content" }, [
                      _c("div", { staticClass: "bill-config" }, [
                        _c(
                          "div",
                          { staticClass: "config-row" },
                          [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("点餐开票"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "请选择销方信息",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.billConfig.dineInvoice,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.billConfig, "dineInvoice", $$v)
                                  },
                                  expression: "billConfig.dineInvoice",
                                },
                              },
                              _vm._l(
                                _vm.invoiceCompanyOptions,
                                function (invoiceCompany) {
                                  return _c("el-option", {
                                    key: invoiceCompany.taxCode,
                                    attrs: {
                                      label: invoiceCompany.title,
                                      value: invoiceCompany.taxCode,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "config-row" },
                          [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("充值开票"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "请选择销方信息",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.billConfig.rechargeInvoice,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.billConfig,
                                      "rechargeInvoice",
                                      $$v
                                    )
                                  },
                                  expression: "billConfig.rechargeInvoice",
                                },
                              },
                              _vm._l(
                                _vm.invoiceCompanyOptions,
                                function (invoiceCompany) {
                                  return _c("el-option", {
                                    key: invoiceCompany.taxCode,
                                    attrs: {
                                      label: invoiceCompany.title,
                                      value: invoiceCompany.taxCode,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "config-row" },
                          [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("购券开票"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "请选择销方信息",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.billConfig.voucherInvoice,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.billConfig,
                                      "voucherInvoice",
                                      $$v
                                    )
                                  },
                                  expression: "billConfig.voucherInvoice",
                                },
                              },
                              _vm._l(
                                _vm.invoiceCompanyOptions,
                                function (invoiceCompany) {
                                  return _c("el-option", {
                                    key: invoiceCompany.taxCode,
                                    attrs: {
                                      label: invoiceCompany.title,
                                      value: invoiceCompany.taxCode,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "config-row" },
                          [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("发票类型"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.billConfig.invoiceType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.billConfig, "invoiceType", $$v)
                                  },
                                  expression: "billConfig.invoiceType",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 0 } }, [
                                  _vm._v("普票"),
                                ]),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("专票"),
                                ]),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: 2 } }, [
                                  _vm._v("电专"),
                                ]),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: 3 } }, [
                                  _vm._v("电普"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.configOptions.delivery
              ? _c(
                  "el-card",
                  { staticClass: "setting-card", attrs: { shadow: "hover" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card-header",
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("i", { staticClass: "el-icon-truck" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("外卖与运费设置")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-content" }, [
                      _c("div", { staticClass: "delivery-config" }, [
                        _c(
                          "div",
                          { staticClass: "price-row" },
                          [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("邮费"),
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "price-input",
                              model: {
                                value: _vm.deliveryConfig.postage,
                                callback: function ($$v) {
                                  _vm.$set(_vm.deliveryConfig, "postage", $$v)
                                },
                                expression: "deliveryConfig.postage",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "unit" }, [_vm._v("元")]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "price-row" },
                          [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("起订额"),
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "price-input",
                              model: {
                                value: _vm.deliveryConfig.minOrder,
                                callback: function ($$v) {
                                  _vm.$set(_vm.deliveryConfig, "minOrder", $$v)
                                },
                                expression: "deliveryConfig.minOrder",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "unit" }, [_vm._v("元")]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "price-row" },
                          [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("免邮额"),
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "price-input",
                              model: {
                                value: _vm.deliveryConfig.freeShipping,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.deliveryConfig,
                                    "freeShipping",
                                    $$v
                                  )
                                },
                                expression: "deliveryConfig.freeShipping",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "unit" }, [_vm._v("元")]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "activity-section" }, [
                          _c(
                            "div",
                            { staticClass: "activity-item" },
                            [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("运费活动"),
                              ]),
                              _vm._v(" "),
                              _c("el-switch", {
                                model: {
                                  value: _vm.deliveryConfig.shippingActivity,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.deliveryConfig,
                                      "shippingActivity",
                                      $$v
                                    )
                                  },
                                  expression: "deliveryConfig.shippingActivity",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.deliveryConfig.shippingActivity
                            ? _c("div", { staticClass: "activity-details" }, [
                                _c(
                                  "div",
                                  { staticClass: "activity-time" },
                                  [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("活动时间"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "daterange",
                                        "range-separator": "至",
                                        "start-placeholder": "开始时间",
                                        "end-placeholder": "结束时间",
                                      },
                                      model: {
                                        value: _vm.deliveryConfig.timeRange,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.deliveryConfig,
                                            "timeRange",
                                            $$v
                                          )
                                        },
                                        expression: "deliveryConfig.timeRange",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "activity-amount" },
                                  [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("活动邮费"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      staticClass: "price-input",
                                      model: {
                                        value:
                                          _vm.deliveryConfig.activityPostage,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.deliveryConfig,
                                            "activityPostage",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "deliveryConfig.activityPostage",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit" }, [
                                      _vm._v("元"),
                                    ]),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "weekly-activity" }, [
                          _c(
                            "div",
                            { staticClass: "activity-item" },
                            [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("周期运费活动"),
                              ]),
                              _vm._v(" "),
                              _c("el-switch", {
                                model: {
                                  value: _vm.deliveryConfig.periodFeeActivity,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.deliveryConfig,
                                      "periodFeeActivity",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "deliveryConfig.periodFeeActivity",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.deliveryConfig.periodFeeActivity
                            ? _c("div", { staticClass: "weekly-details" }, [
                                _c(
                                  "div",
                                  { staticClass: "config-row" },
                                  [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("是否启用"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-switch", {
                                      attrs: {
                                        "active-value": 1,
                                        "inactive-value": 0,
                                      },
                                      model: {
                                        value:
                                          _vm.deliveryConfig.periodFee.enable,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.deliveryConfig.periodFee,
                                            "enable",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "deliveryConfig.periodFee.enable",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "weekly-days" }, [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v("星期"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "week-select-wrapper" },
                                    [
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          model: {
                                            value:
                                              _vm.deliveryConfig.periodFee
                                                .weeks,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.deliveryConfig.periodFee,
                                                "weeks",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "deliveryConfig.periodFee.weeks",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-checkbox",
                                            { attrs: { label: 1 } },
                                            [_vm._v("周一")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-checkbox",
                                            { attrs: { label: 2 } },
                                            [_vm._v("周二")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-checkbox",
                                            { attrs: { label: 3 } },
                                            [_vm._v("周三")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-checkbox",
                                            { attrs: { label: 4 } },
                                            [_vm._v("周四")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-checkbox",
                                            { attrs: { label: 5 } },
                                            [_vm._v("周五")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-checkbox",
                                            { attrs: { label: 6 } },
                                            [_vm._v("周六")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-checkbox",
                                            { attrs: { label: 7 } },
                                            [_vm._v("周日")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-checkbox",
                                        {
                                          staticClass: "select-all-checkbox",
                                          attrs: {
                                            indeterminate:
                                              _vm.isPeriodFeeWeekIndeterminate,
                                          },
                                          on: {
                                            change:
                                              _vm.handlePeriodFeeWeekSelectAll,
                                          },
                                          model: {
                                            value:
                                              _vm.isPeriodFeeWeekAllSelected,
                                            callback: function ($$v) {
                                              _vm.isPeriodFeeWeekAllSelected =
                                                $$v
                                            },
                                            expression:
                                              "isPeriodFeeWeekAllSelected",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                        全选\n                      "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "weekly-date-range" },
                                  [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("有效日期"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "daterange",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                      },
                                      model: {
                                        value:
                                          _vm.deliveryConfig.periodFee
                                            .dateRange,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.deliveryConfig.periodFee,
                                            "dateRange",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "deliveryConfig.periodFee.dateRange",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "weekly-time-range" },
                                  [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("活动时间"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-time-picker", {
                                      attrs: {
                                        placeholder: "开始时间",
                                        format: "HH:mm",
                                        "value-format": "HH:mm",
                                      },
                                      model: {
                                        value:
                                          _vm.deliveryConfig.periodFee
                                            .dayStartTime,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.deliveryConfig.periodFee,
                                            "dayStartTime",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "deliveryConfig.periodFee.dayStartTime",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "separator" }, [
                                      _vm._v("至"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-time-picker", {
                                      attrs: {
                                        placeholder: "结束时间",
                                        format: "HH:mm",
                                        "value-format": "HH:mm",
                                      },
                                      model: {
                                        value:
                                          _vm.deliveryConfig.periodFee
                                            .dayEndTime,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.deliveryConfig.periodFee,
                                            "dayEndTime",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "deliveryConfig.periodFee.dayEndTime",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "weekly-amount" },
                                  [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("活动邮费"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      staticClass: "price-input",
                                      model: {
                                        value: _vm.deliveryConfig.periodFee.fee,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.deliveryConfig.periodFee,
                                            "fee",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "deliveryConfig.periodFee.fee",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit" }, [
                                      _vm._v("元"),
                                    ]),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.configOptions.businessTime
              ? _c(
                  "el-card",
                  { staticClass: "setting-card", attrs: { shadow: "hover" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card-header",
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("i", { staticClass: "el-icon-clock" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("营业时间配置")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-content" }, [
                      _c("div", { staticClass: "business-time-config" }, [
                        _c(
                          "div",
                          { staticClass: "week-selection" },
                          [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("选择星期"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-checkbox-group",
                              {
                                model: {
                                  value: _vm.businessTimeConfig.selectedWeeks,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.businessTimeConfig,
                                      "selectedWeeks",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "businessTimeConfig.selectedWeeks",
                                },
                              },
                              [
                                _c("el-checkbox", { attrs: { label: 1 } }, [
                                  _vm._v("周一"),
                                ]),
                                _vm._v(" "),
                                _c("el-checkbox", { attrs: { label: 2 } }, [
                                  _vm._v("周二"),
                                ]),
                                _vm._v(" "),
                                _c("el-checkbox", { attrs: { label: 3 } }, [
                                  _vm._v("周三"),
                                ]),
                                _vm._v(" "),
                                _c("el-checkbox", { attrs: { label: 4 } }, [
                                  _vm._v("周四"),
                                ]),
                                _vm._v(" "),
                                _c("el-checkbox", { attrs: { label: 5 } }, [
                                  _vm._v("周五"),
                                ]),
                                _vm._v(" "),
                                _c("el-checkbox", { attrs: { label: 6 } }, [
                                  _vm._v("周六"),
                                ]),
                                _vm._v(" "),
                                _c("el-checkbox", { attrs: { label: 7 } }, [
                                  _vm._v("周日"),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "select-all-btn",
                                attrs: { type: "text" },
                                on: { click: _vm.selectAllWeeks },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.businessTimeConfig.selectedWeeks
                                        .length === 7
                                        ? "取消全选"
                                        : "全选"
                                    ) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "order-type-time" }, [
                          _c("div", { staticClass: "order-type-header" }, [
                            _c("span", { staticClass: "type-label" }, [
                              _vm._v("点餐类型"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "time-range-label" }, [
                              _vm._v("营业时间"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "order-type-row" },
                            [
                              _c("span", { staticClass: "type-name" }, [
                                _vm._v("堂食"),
                              ]),
                              _vm._v(" "),
                              _c("el-time-picker", {
                                attrs: {
                                  placeholder: "开始时间",
                                  format: "HH:mm",
                                  "value-format": "HH:mm",
                                  size: "small",
                                },
                                model: {
                                  value: _vm.businessTimeConfig.ts.startTime,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.businessTimeConfig.ts,
                                      "startTime",
                                      $$v
                                    )
                                  },
                                  expression: "businessTimeConfig.ts.startTime",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "separator" }, [
                                _vm._v("至"),
                              ]),
                              _vm._v(" "),
                              _c("el-time-picker", {
                                attrs: {
                                  placeholder: "结束时间",
                                  format: "HH:mm",
                                  "value-format": "HH:mm",
                                  size: "small",
                                },
                                model: {
                                  value: _vm.businessTimeConfig.ts.endTime,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.businessTimeConfig.ts,
                                      "endTime",
                                      $$v
                                    )
                                  },
                                  expression: "businessTimeConfig.ts.endTime",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "order-type-row" },
                            [
                              _c("span", { staticClass: "type-name" }, [
                                _vm._v("自提"),
                              ]),
                              _vm._v(" "),
                              _c("el-time-picker", {
                                attrs: {
                                  placeholder: "开始时间",
                                  format: "HH:mm",
                                  "value-format": "HH:mm",
                                  size: "small",
                                },
                                model: {
                                  value: _vm.businessTimeConfig.zt.startTime,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.businessTimeConfig.zt,
                                      "startTime",
                                      $$v
                                    )
                                  },
                                  expression: "businessTimeConfig.zt.startTime",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "separator" }, [
                                _vm._v("至"),
                              ]),
                              _vm._v(" "),
                              _c("el-time-picker", {
                                attrs: {
                                  placeholder: "结束时间",
                                  format: "HH:mm",
                                  "value-format": "HH:mm",
                                  size: "small",
                                },
                                model: {
                                  value: _vm.businessTimeConfig.zt.endTime,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.businessTimeConfig.zt,
                                      "endTime",
                                      $$v
                                    )
                                  },
                                  expression: "businessTimeConfig.zt.endTime",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "order-type-row" },
                            [
                              _c("span", { staticClass: "type-name" }, [
                                _vm._v("外卖"),
                              ]),
                              _vm._v(" "),
                              _c("el-time-picker", {
                                attrs: {
                                  placeholder: "开始时间",
                                  format: "HH:mm",
                                  "value-format": "HH:mm",
                                  size: "small",
                                },
                                model: {
                                  value: _vm.businessTimeConfig.ws.startTime,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.businessTimeConfig.ws,
                                      "startTime",
                                      $$v
                                    )
                                  },
                                  expression: "businessTimeConfig.ws.startTime",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "separator" }, [
                                _vm._v("至"),
                              ]),
                              _vm._v(" "),
                              _c("el-time-picker", {
                                attrs: {
                                  placeholder: "结束时间",
                                  format: "HH:mm",
                                  "value-format": "HH:mm",
                                  size: "small",
                                },
                                model: {
                                  value: _vm.businessTimeConfig.ws.endTime,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.businessTimeConfig.ws,
                                      "endTime",
                                      $$v
                                    )
                                  },
                                  expression: "businessTimeConfig.ws.endTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.configOptions.orderMode
              ? _c(
                  "el-card",
                  { staticClass: "setting-card", attrs: { shadow: "hover" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card-header",
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("i", { staticClass: "el-icon-food" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("点餐模式配置")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-content" }, [
                      _c(
                        "div",
                        { staticClass: "order-mode-config-only" },
                        [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("点餐模式"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.orderModeConfig.orderMode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.orderModeConfig,
                                    "orderMode",
                                    $$v
                                  )
                                },
                                expression: "orderModeConfig.orderMode",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("快餐"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("中餐"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.configOptions.booking
              ? _c(
                  "el-card",
                  { staticClass: "setting-card", attrs: { shadow: "hover" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card-header",
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("i", { staticClass: "el-icon-date" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("预订设置")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-content" }, [
                      _c("div", { staticClass: "booking-config" }, [
                        _c(
                          "div",
                          { staticClass: "config-row" },
                          [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("是否可预订"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.bookingConfig.canBook,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.bookingConfig, "canBook", $$v)
                                  },
                                  expression: "bookingConfig.canBook",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 0 } }, [
                                  _vm._v("不可预订"),
                                ]),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("可预订"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.bookingConfig.canBook === 1
                          ? _c(
                              "div",
                              { staticClass: "config-row" },
                              [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("预订时间"),
                                ]),
                                _vm._v(" "),
                                _c("el-time-picker", {
                                  attrs: {
                                    placeholder: "请选择时间",
                                    format: "HH:mm",
                                    "value-format": "HH:mm",
                                  },
                                  model: {
                                    value: _vm.bookingConfig.preTime,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.bookingConfig,
                                        "preTime",
                                        $$v
                                      )
                                    },
                                    expression: "bookingConfig.preTime",
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "tip-text" }, [
                                  _vm._v("最早可预订时间点"),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.configOptions.busyTime
              ? _c(
                  "el-card",
                  { staticClass: "setting-card", attrs: { shadow: "hover" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card-header",
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("i", { staticClass: "el-icon-timer" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("繁忙时段设置")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-content" }, [
                      _c("div", { staticClass: "busy-time-config" }, [
                        _c(
                          "div",
                          { staticClass: "busy-time-section" },
                          [
                            _c("span", { staticClass: "label" }, [
                              _vm._v("繁忙时间段"),
                            ]),
                            _vm._v(" "),
                            _vm._l(
                              _vm.busyTimeConfig.bsyTimeGroup,
                              function (time, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "busy-time-item" },
                                  [
                                    _c("el-time-picker", {
                                      attrs: {
                                        placeholder: "开始时间",
                                        format: "HH:mm",
                                        "value-format": "HH:mm",
                                        size: "small",
                                      },
                                      model: {
                                        value: time.start,
                                        callback: function ($$v) {
                                          _vm.$set(time, "start", $$v)
                                        },
                                        expression: "time.start",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "separator" }, [
                                      _vm._v("至"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-time-picker", {
                                      attrs: {
                                        placeholder: "结束时间",
                                        format: "HH:mm",
                                        "value-format": "HH:mm",
                                        size: "small",
                                      },
                                      model: {
                                        value: time.end,
                                        callback: function ($$v) {
                                          _vm.$set(time, "end", $$v)
                                        },
                                        expression: "time.end",
                                      },
                                    }),
                                    _vm._v(" "),
                                    index !== 0
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeBusyTime(index)
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-delete",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              }
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "add-time-btn",
                                attrs: { type: "text", size: "small" },
                                on: { click: _vm.addBusyTime },
                              },
                              [
                                _c("i", { staticClass: "el-icon-plus" }),
                                _vm._v(" 添加时间段\n                "),
                              ]
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "busy-plus-section" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("繁忙加时"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "input-with-unit" },
                            [
                              _c("el-input-number", {
                                attrs: { min: 0, max: 120, size: "small" },
                                model: {
                                  value: _vm.busyTimeConfig.bsyPlusTime,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.busyTimeConfig,
                                      "bsyPlusTime",
                                      $$v
                                    )
                                  },
                                  expression: "busyTimeConfig.bsyPlusTime",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "unit" }, [
                                _vm._v("分钟"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "tip-text" }, [
                            _vm._v("繁忙时段下单时额外加时"),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.configOptions.business
              ? _c(
                  "el-card",
                  { staticClass: "setting-card", attrs: { shadow: "hover" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card-header",
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("i", { staticClass: "el-icon-time" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("公告设置")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "weekly-activity" }, [
                      _c(
                        "div",
                        { staticClass: "weekly-details" },
                        _vm._l(_vm.cards, function (item) {
                          return _c(
                            "div",
                            { key: item.key, staticClass: "notice-card" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "card-title",
                                  staticStyle: {
                                    height: "40px",
                                    color: "#9da408",
                                  },
                                  attrs: { align: "center" },
                                },
                                [_vm._v(_vm._s(item.label))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "card-body" },
                                [
                                  _c(
                                    "el-form",
                                    { attrs: { "label-width": "80px" } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "icon" } },
                                        [
                                          _c(
                                            "el-upload",
                                            {
                                              staticClass: "icon-uploader",
                                              attrs: {
                                                action: "#",
                                                "list-type": "picture-card",
                                                "file-list":
                                                  _vm.innerNotices[item.key]
                                                    .iconUrl,
                                                limit: 1,
                                                "on-remove": function () {
                                                  return _vm.handleRemove(
                                                    item.key
                                                  )
                                                },
                                                "on-exceed": _vm.handleExceed,
                                                "auto-upload": false,
                                                "http-request": function () {},
                                                "before-upload": function (
                                                  file
                                                ) {
                                                  return _vm.handleUpload(
                                                    file,
                                                    item.key
                                                  )
                                                },
                                                "on-change": function (
                                                  file,
                                                  fileList
                                                ) {
                                                  return _vm.handleChange(
                                                    file,
                                                    fileList,
                                                    item.key
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-plus",
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "有效日期" } },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "350px" },
                                            attrs: {
                                              type: "daterange",
                                              "range-separator": "至",
                                              "start-placeholder": "开始日期",
                                              "end-placeholder": "结束日期",
                                              "value-format": "yyyy-MM-dd",
                                            },
                                            model: {
                                              value:
                                                _vm.innerNotices[item.key]
                                                  .dateRange,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.innerNotices[item.key],
                                                  "dateRange",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "innerNotices[item.key].dateRange",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "星期" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-checkbox-group",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "flex-wrap": "wrap",
                                                    gap: "8px",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.innerNotices[item.key]
                                                        .weeks,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.innerNotices[
                                                          item.key
                                                        ],
                                                        "weeks",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "innerNotices[item.key].weeks",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-checkbox",
                                                    { attrs: { label: 1 } },
                                                    [_vm._v("一")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-checkbox",
                                                    { attrs: { label: 2 } },
                                                    [_vm._v("二")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-checkbox",
                                                    { attrs: { label: 3 } },
                                                    [_vm._v("三")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-checkbox",
                                                    { attrs: { label: 4 } },
                                                    [_vm._v("四")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-checkbox",
                                                    { attrs: { label: 5 } },
                                                    [_vm._v("五")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-checkbox",
                                                    { attrs: { label: 6 } },
                                                    [_vm._v("六")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-checkbox",
                                                    { attrs: { label: 7 } },
                                                    [_vm._v("日")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-checkbox",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "8px",
                                                  },
                                                  attrs: {
                                                    indeterminate:
                                                      _vm.isNoticeWeekIndeterminate(
                                                        item.key
                                                      ),
                                                    value:
                                                      _vm.isNoticeWeekAllSelected(
                                                        item.key
                                                      ),
                                                  },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.handleNoticeWeekSelectAll(
                                                        item.key
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          全选\n                        "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "时间段" } },
                                        [
                                          _c("el-time-picker", {
                                            attrs: {
                                              placeholder: "开始时间",
                                              "value-format": "HH:mm:ss",
                                            },
                                            model: {
                                              value:
                                                _vm.innerNotices[item.key]
                                                  .timeRange.start,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.innerNotices[item.key]
                                                    .timeRange,
                                                  "start",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "innerNotices[item.key].timeRange.start",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "mx-2" }, [
                                            _vm._v("至"),
                                          ]),
                                          _vm._v(" "),
                                          _c("el-time-picker", {
                                            attrs: {
                                              placeholder: "结束时间",
                                              "value-format": "HH:mm:ss",
                                            },
                                            model: {
                                              value:
                                                _vm.innerNotices[item.key]
                                                  .timeRange.end,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.innerNotices[item.key]
                                                    .timeRange,
                                                  "end",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "innerNotices[item.key].timeRange.end",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "标题" } },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "输入公告标题",
                                            },
                                            model: {
                                              value:
                                                _vm.innerNotices[item.key]
                                                  .title,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.innerNotices[item.key],
                                                  "title",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "innerNotices[item.key].title",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "内容" } },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              type: "textarea",
                                              rows: 3,
                                              placeholder: "请输入公告内容",
                                            },
                                            model: {
                                              value:
                                                _vm.innerNotices[item.key]
                                                  .content,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.innerNotices[item.key],
                                                  "content",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "innerNotices[item.key].content",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.configOptions.welfare
              ? _c(
                  "el-card",
                  { staticClass: "setting-card", attrs: { shadow: "hover" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card-header",
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("i", { staticClass: "el-icon-present" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("福利社设置")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "welfare-config" }, [
                      _c(
                        "div",
                        { staticClass: "welfare-item" },
                        [
                          _c(
                            "el-form",
                            { attrs: { "label-width": "80px" } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "福利社背景图片" } },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      staticClass: "welfare-uploader",
                                      attrs: {
                                        action: "#",
                                        "list-type": "picture-card",
                                        "file-list": _vm.welfareConfig.imageUrl,
                                        limit: 1,
                                        "on-remove": _vm.handleWelfareRemove,
                                        "on-exceed": _vm.handleWelfareExceed,
                                        "auto-upload": false,
                                        "http-request": function () {},
                                        "before-upload":
                                          _vm.handleWelfareUpload,
                                        "on-change": _vm.handleWelfareChange,
                                      },
                                    },
                                    [_c("i", { staticClass: "el-icon-plus" })]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.configOptions.qrBgImage
              ? _c(
                  "el-card",
                  { staticClass: "setting-card", attrs: { shadow: "hover" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card-header",
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("i", { staticClass: "el-icon-picture" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("二维码背景图设置")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "qr-bg-config" }, [
                      _c(
                        "div",
                        { staticClass: "qr-bg-item" },
                        [
                          _c(
                            "el-form",
                            { attrs: { "label-width": "80px" } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "二维码背景图片" } },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      staticClass: "qr-bg-uploader",
                                      attrs: {
                                        action: "#",
                                        "list-type": "picture-card",
                                        "file-list": _vm.qrBgConfig.imageUrl,
                                        limit: 1,
                                        "on-remove": _vm.handleQrBgRemove,
                                        "on-exceed": _vm.handleQrBgExceed,
                                        "auto-upload": false,
                                        "http-request": function () {},
                                        "before-upload": _vm.handleQrBgUpload,
                                        "on-change": _vm.handleQrBgChange,
                                      },
                                    },
                                    [_c("i", { staticClass: "el-icon-plus" })]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.configOptions.bookingTime
              ? _c("BookingTimeConfig", {
                  ref: "bookingTimeConfig",
                  attrs: { "is-in-batch-setting": true },
                  on: { submit: _vm.handleBookingTimeSubmit },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right-panel" },
          [
            _c(
              "el-card",
              { staticClass: "store-card", attrs: { shadow: "hover" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "card-header",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("i", { staticClass: "el-icon-office-building" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("门店选择")]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: { click: _vm.selectAllStores },
                      },
                      [
                        _c("i", { staticClass: "el-icon-check" }),
                        _vm._v(" 全选\n            "),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c(
                    "div",
                    { staticClass: "search-box" },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入关键字进行筛选",
                          "prefix-icon": "el-icon-search",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.storeSearchText,
                          callback: function ($$v) {
                            _vm.storeSearchText = $$v
                          },
                          expression: "storeSearchText",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "store-tree" },
                    [
                      _c("el-tree", {
                        ref: "storeTree",
                        attrs: {
                          data: _vm.storeTreeData,
                          "show-checkbox": "",
                          "node-key": "id",
                          "default-expanded-keys": _vm.expandedKeys,
                          "default-checked-keys": _vm.checkedKeys,
                          props: _vm.defaultProps,
                          "filter-node-method": _vm.filterNode,
                        },
                        on: { "check-change": _vm.handleStoreCheck },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "action-buttons" },
        [
          _c(
            "el-button",
            { attrs: { size: "medium" }, on: { click: _vm.handleCancel } },
            [_vm._v("\n                 取消\n              ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "medium" },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("\n                 确定\n              ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }